import { Component, OnInit, Inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DocumentsService } from 'app/services/documents/documents.service';
import { Store } from '@ngxs/store';
import { GetBorrowerDocuments } from 'ng2-app/store/documents/document.actions';

@Component({
  selector: 'app-app-preview-dialog',
  templateUrl: './app-preview-dialog.component.html',
  styleUrls: ['./app-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppPreviewDialogComponent implements OnInit {
  html: SafeHtml;
  loading = true;

  constructor(
    private documentService: DocumentsService,
    @Inject(MAT_DIALOG_DATA) private data: { borrowerId: number },
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<AppPreviewDialogComponent>,
    private store: Store
  ) { }

  ngOnInit() {
    this.documentService.getApplicationPreview(this.data.borrowerId).subscribe((response: { html: string }) => {
      this.html = this.sanitizer.bypassSecurityTrustHtml(response.html);
      this.loading = false;
      this.cdRef.markForCheck();
    });
  }

  saveApplication() {
    this.loading = true;
    this.documentService.saveApplication(this.data.borrowerId).subscribe(() => {
        this.store.dispatch(new GetBorrowerDocuments(this.data.borrowerId, true));
        this.dialogRef.close();
    });
  }
}
